export default (client, defaultParams) => ({
  find: (payload) =>
    client('/admin/renewals/find', {
      method: 'POST',
      data: payload,
      params: {
        ...defaultParams,
      },
    }),
});
